<template>
  <g>
    <g clip-path="url(#clip0_15_319)">
      <path
        d="M6 18.0002C6 18.5502 6.45 19.0002 7 19.0002H8V22.5002C8 23.3302 8.67 24.0002 9.5 24.0002C10.33 24.0002 11 23.3302 11 22.5002V19.0002H13V22.5002C13 23.3302 13.67 24.0002 14.5 24.0002C15.33 24.0002 16 23.3302 16 22.5002V19.0002H17C17.55 19.0002 18 18.5502 18 18.0002V8.00018H6V18.0002ZM3.5 8.00018C2.67 8.00018 2 8.67018 2 9.50018V16.5002C2 17.3302 2.67 18.0002 3.5 18.0002C4.33 18.0002 5 17.3302 5 16.5002V9.50018C5 8.67018 4.33 8.00018 3.5 8.00018ZM20.5 8.00018C19.67 8.00018 19 8.67018 19 9.50018V16.5002C19 17.3302 19.67 18.0002 20.5 18.0002C21.33 18.0002 22 17.3302 22 16.5002V9.50018C22 8.67018 21.33 8.00018 20.5 8.00018ZM15.53 2.16018L16.83 0.860183C17.03 0.660183 17.03 0.350183 16.83 0.150183C16.63 -0.0498169 16.32 -0.0498169 16.12 0.150183L14.64 1.63018C13.85 1.23018 12.95 1.00018 12 1.00018C11.04 1.00018 10.14 1.23018 9.34 1.63018L7.85 0.150183C7.65 -0.0498169 7.34 -0.0498169 7.14 0.150183C6.94 0.350183 6.94 0.660183 7.14 0.860183L8.45 2.17018C6.97 3.26018 6 5.01018 6 7.00018H18C18 5.01018 17.03 3.25018 15.53 2.16018ZM10 5.00018H9V4.00018H10V5.00018ZM15 5.00018H14V4.00018H15V5.00018Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_319">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
